import type { CartItem } from '../store/cartStore';
import {
  getMarketplaceFeePercentage,
  getMarketplaceName,
  isSupportedMarketplace,
} from '../lib/marketplace-constants';

export interface FeeBreakdownEntry {
  marketplace: string;
  feePercentage: number;
  feeAmount: number;
  itemCount: number;
}

export interface CartTotals {
  subtotal: number;
  fees: number;
  total: number;
  feeBreakdown: FeeBreakdownEntry[];
}

export function calculateCartTotals(items: CartItem[]): CartTotals {
  let subtotal = 0;
  let fees = 0;
  const feeMap = new Map<string, { feePercentage: number; feeAmount: number; itemCount: number }>();

  for (const item of items) {
    const priceXrp = Number(item.price_xrp) || 0;
    subtotal += priceXrp;

    if (item.destination && isSupportedMarketplace(item.destination)) {
      const feePercentage = getMarketplaceFeePercentage(item.destination);
      const feeAmount = priceXrp * (feePercentage / 100);
      fees += feeAmount;

      const name = getMarketplaceName(item.destination);
      const existing = feeMap.get(name);
      if (existing) {
        existing.feeAmount += feeAmount;
        existing.itemCount += 1;
      } else {
        feeMap.set(name, { feePercentage, feeAmount, itemCount: 1 });
      }
    }
  }

  const feeBreakdown: FeeBreakdownEntry[] = Array.from(feeMap.entries()).map(
    ([marketplace, data]) => ({
      marketplace,
      feePercentage: data.feePercentage,
      feeAmount: data.feeAmount,
      itemCount: data.itemCount,
    })
  );

  return {
    subtotal,
    fees,
    total: subtotal + fees,
    feeBreakdown,
  };
}
